const faqs = [
  {
    q: '51每日大赛是什么？真的24小时更新吗？',
    a: '51每日大赛是全网最大的素人网红翻车与娱乐圈内幕追踪平台，编辑团队24小时轮班值守，确保第一时间将最新反差视频、酒店猛料和娱乐圈不雅内幕推送至首页。无论深夜还是凌晨，吃瓜永不打烊。',
  },
  {
    q: '51每日大赛的爆料内容来源可靠吗？',
    a: '所有爆料均经过多渠道交叉验证，由资深吃瓜编辑团队人工审核后发布。我们坚持\"有料必查、无据不发\"的原则，同时保护爆料人绝对匿名，确保每一条信息的真实性和安全性。',
  },
  {
    q: '如何第一时间获取51每日大赛的最新爆料？',
    a: '你可以将51每日大赛加入浏览器收藏夹，或关注我们的社交媒体账号获取实时推送。首页\"今日大赛热度榜\"每小时刷新一次，\"24小时实时快讯\"模块保持分钟级更新节奏，确保你不会错过任何大瓜。',
  },
  {
    q: '我也有猛料想爆，如何匿名投稿？',
    a: '点击首页\"投稿爆料\"按钮或直接访问\"爆料投稿入口\"模块，通过匿名通道提交你的线索。我们采用端到端加密传输，投稿人信息完全不可追溯。经编辑核实后，高质量爆料将获得优先展示和现金奖励。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-black text-foreground-950 mb-10 text-center">
          吃瓜必读FAQ
        </h2>
        <div className="flex flex-col gap-4">
          {faqs.map((faq, idx) => (
            <div key={idx} className="bg-background-100 rounded-2xl p-5 md:p-6">
              <h3 className="text-base md:text-lg font-bold text-foreground-900 mb-2">
                {faq.q}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {faq.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}